
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Exploreallindiabushire() {



    const cardData =
    {
        keyword: 'Explore All India Bus Hire Services From Pune',
        heading: 'Amruta Travels: Explore All India Bus Hire Services From Pune',
        headingDescription: 'Amruta Travels offers Explore All India Bus Hire Services from Pune, catering to long-distance travel across India with comfort, safety, and reliability. Whether you are planning a multi-day pilgrimage, corporate tour, school excursion, or family vacation, we provide well-maintained buses and professional drivers to ensure a seamless travel experience anywhere in India.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

   "services": [
    {
      "name": "Pune to Somnath Gujarat Bus On Rent",
      "description": "Amruta Travels offers comfortable bus services from Pune to Somnath, Gujarat. Ideal for pilgrimages and group tours, our buses are equipped with AC, pushback seats, and experienced drivers to ensure a smooth journey."
    },
    {
      "name": "Pune to Badrinath Bus Hire on Rent",
      "description": "Embark on a spiritual journey to Badrinath with our reliable bus hire services. Our buses are well-maintained and designed for long-distance travel, providing comfort and safety for your group."
    },
    {
      "name": "Pune to Kedarnath Bus Hire on Rent",
      "description": "Travel to the sacred Kedarnath temple with ease. Our bus services from Pune offer comfortable seating and experienced drivers, ensuring a safe and pleasant pilgrimage experience."
    },
    {
      "name": "Pune to Madhya Pradesh Bus for Trip",
      "description": "Explore the cultural heritage of Madhya Pradesh with our bus hire services. We provide well-maintained buses for group tours, ensuring comfort and convenience throughout your journey."
    },
    {
      "name": "Pune to Mysore Ooty Bus Tour Package",
      "description": "Discover the scenic beauty of Mysore and Ooty with our exclusive bus tour package. Our buses are equipped with modern amenities to provide a comfortable and memorable travel experience."
    },
    {
      "name": "Pune Dev Darshan Bus for Trip",
      "description": "Experience a spiritual journey with our Dev Darshan bus services. We offer customized packages to various religious destinations, ensuring a peaceful and comfortable trip."
    },
    {
      "name": "Pune to Nashik Darshan Bus Hire",
      "description": "Visit the sacred sites of Nashik with our bus hire services. Our buses are equipped with AC and comfortable seating, making your pilgrimage journey pleasant and hassle-free."
    },
    {
      "name": "Pune to Rajasthan Bus On Rent",
      "description": "Explore the royal state of Rajasthan with our bus rental services. We provide well-maintained buses for group tours, ensuring comfort and safety during your travels."
    },
    {
      "name": "Bus On Hire in Ujjain",
      "description": "Visit the holy city of Ujjain with our bus hire services. Our buses are designed for long-distance travel, providing comfort and convenience for your group."
    },
    {
      "name": "Best Traveller Bus On Rent",
      "description": "Choose from our fleet of best-in-class traveller buses for your group travel needs. Our buses are equipped with modern amenities to ensure a comfortable journey."
    },
    {
      "name": "Pune to 12 Jyotirlinga Darshan Tour Package",
      "description": "Embark on a spiritual journey covering all 12 Jyotirlingas with our comprehensive tour package. Our buses are equipped with AC and comfortable seating, ensuring a pleasant pilgrimage experience."
    },
    {
      "name": "7 Jyotirlinga Tour Package Bus Hire in Pune",
      "description": "Experience the divine journey of visiting 7 Jyotirlingas with our specialized bus hire services. We provide comfortable and reliable transportation for your spiritual tour."
    },
    {
      "name": "Pune to All India Bus Hire",
      "description": "Explore various destinations across India with our all-inclusive bus hire services. We offer customized packages to suit your travel needs, ensuring comfort and convenience."
    },
    {
      "name": "Pune to Hyderabad Mini Bus on Rent",
      "description": "Travel to Hyderabad in style with our mini bus rental services. Our buses are equipped with modern amenities to provide a comfortable and enjoyable journey."
    },
    {
      "name": "Pune to Goa 14 17 20 25 Seater Bus Hire",
      "description": "Plan your trip to Goa with our range of bus hire options. We offer 14, 17, 20, and 25-seater buses, ensuring a comfortable ride for your group."
    },
    {
      "name": "Pune to Karnataka Bus Hire for Rent",
      "description": "Discover the beauty of Karnataka with our bus hire services. We provide well-maintained buses for group tours, ensuring a comfortable and safe journey."
    },
    {
      "name": "Pune to Maharashtra Darshan Bus On Rent",
      "description": "Explore the religious sites of Maharashtra with our bus hire services. Our buses are equipped with AC and comfortable seating, making your pilgrimage journey pleasant."
    },
    {
      "name": "5, 40, 45, 50 Seater Bus Rental for Agra Pune",
      "description": "Visit the historic city of Agra with our flexible bus rental options. Choose from 5, 40, 45, or 50-seater buses, ensuring a comfortable ride for your group."
    },
    {
      "name": "Pan India Bus Service From Pune",
      "description": "Travel across India with our comprehensive bus services. We offer customized packages to various destinations, ensuring comfort and convenience throughout your journey."
    }
  ],
  "tableData": [
    ["Pune to Somnath Gujarat Bus On Rent", "Pune to Badrinath Bus Hire on Rent"],
    ["Pune to Kedarnath Bus Hire on Rent", "Pune to Madhya Pradesh Bus for Trip"],
    ["Pune to Mysore Ooty Bus Tour Package", "Pune Dev Darshan Bus for Trip"],
    ["Pune to Nashik Darshan Bus Hire", "Pune to Rajasthan Bus On Rent"],
    ["Bus On Hire in Ujjain", "Best Traveller Bus On Rent"],
    ["Pune to 12 Jyotirlinga Darshan Tour Package", "7 Jyotirlinga Tour Package Bus Hire in Pune"],
    ["Pune to All India Bus Hire", "Pune to Hyderabad Mini Bus on Rent"],
    ["Pune to Goa 14 17 20 25 Seater Bus Hire", "Pune to Karnataka Bus Hire for Rent"],
    ["Pune to Maharashtra Darshan Bus On Rent", "5, 40, 45, 50 Seater Bus Rental for Agra Pune"],
    ["Pan India Bus Service From Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "All India Bus Hire Services from Pune for Long-Distance Travel",
    "WhyChoosedescription": "Amruta Travels offers reliable and comfortable All India bus hire services from Pune, perfect for long-distance tours, pilgrimages, corporate outings, and destination weddings. Our well-maintained buses are ready to take your group anywhere across India with comfort and ease."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimages, Educational Tours, and Group Travel",
    "WhyChoosedescription": "Whether it’s a trip to Shirdi, Goa, Rajasthan, Kerala, or Himachal, our buses are perfect for large groups traveling across states. We cater to schools, colleges, corporate teams, and families, ensuring everyone travels together comfortably and safely."
  },
  {
    "WhyChooseheading": "Wide Range of Buses to Suit Every Group Size",
    "WhyChoosedescription": "We offer a wide selection of vehicles for All India travel including 17-seaters, 30-seaters, 35-seaters, and luxury coaches. Choose the right bus based on your group size and travel preference—all equipped with modern amenities for a smooth journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent All-Inclusive Pricing",
    "WhyChoosedescription": "Our All India bus hire services from Pune come with competitive and all-inclusive pricing. The quote includes fuel, tolls, driver charges, interstate permits, and taxes—no hidden costs, just transparent pricing so you can plan confidently."
  },
  {
    "WhyChooseheading": "Comfortable and Fully-Equipped Buses for Long Journeys",
    "WhyChoosedescription": "Our buses are equipped with reclining seats, air conditioning, charging ports, entertainment systems, and large luggage compartments. These features ensure that even long journeys across India remain comfortable and fatigue-free for all passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers and Route Expertise Across India",
    "WhyChoosedescription": "Our professional drivers are experienced in handling long routes and are familiar with destinations across India. They ensure safe, timely travel and assist with navigating different state rules and conditions for a stress-free trip."
  },
  {
    "WhyChooseheading": "Customizable Itineraries and Flexible Travel Plans",
    "WhyChoosedescription": "With Amruta Travels, you can customize your route, destinations, and stops across India. Whether it's a multi-state tour or a one-way drop, we offer flexible travel options tailored to your group’s needs and schedule."
  },
  {
    "WhyChooseheading": "24/7 Customer Support Throughout Your Journey",
    "WhyChoosedescription": "Our dedicated support team is available 24/7 to assist you before, during, and after your journey. From booking assistance to en-route support, we ensure a smooth experience for your All India travel from Pune."
  }
]

























    }

const faqData = [
  {
    question: 'Does Amruta Travels offer all India bus hire services from Pune?',
    answer: 'Yes, Amruta Travels provides reliable all India bus hire services from Pune. Whether you are planning a tour, pilgrimage, wedding, or corporate event across India, we have suitable buses for your long-distance travel needs.',
  },
  {
    question: 'What types of buses are available for all India travel from Pune?',
    answer: 'We offer a wide range of buses including 17-seater Tempo Travellers, 32-seater, 40-seater, and 50-seater deluxe and BharatBenz buses. Options include AC, Non-AC, luxury, and sleeper coaches to match your comfort and budget.',
  },
  {
    question: 'Is a driver included in the all India bus rental service?',
    answer: 'Yes, all our all India bus hire packages include a professional and experienced driver who is well-versed with interstate travel routes, ensuring your journey is smooth and safe.',
  },
  {
    question: 'Can I book a bus from Pune for multi-day or long-distance tours across India?',
    answer: 'Absolutely. Our buses are ideal for multi-day trips and long-distance journeys across various Indian states. Popular routes include Pune to Delhi, Rajasthan, Gujarat, Kerala, Himachal Pradesh, and more.',
  },
  {
    question: 'What is the cost of hiring a bus for all India travel from Pune?',
    answer: 'The rental cost depends on the bus type, number of travel days, distance, and services required. We offer competitive rates and customized packages. Contact us with your itinerary for an accurate quote.',
  },
  {
    question: 'Are the buses well-maintained and equipped for long journeys?',
    answer: 'Yes, all our buses are regularly serviced, equipped with modern amenities, and sanitized before each trip. We ensure maximum comfort, safety, and reliability for long-distance travel.',
  },
  {
    question: 'Can I book the all India bus hire service online from Pune?',
    answer: 'Yes, you can easily book our all India bus hire services through our website or by contacting our customer support team. We provide complete assistance from booking to trip completion.',
  },
  {
    question: 'Is Amruta Travels suitable for group tours and pan-India travel plans?',
    answer: 'Definitely. We specialize in group travel, all India pilgrimage tours, college or school excursions, corporate retreats, and destination weddings across India. Our team ensures a seamless experience from start to finish.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    role: 'Tour Operator, Pune',
    text: 'We booked a 50-seater BharatBenz bus from Amruta Travels for a 10-day North India tour. The bus was extremely comfortable and reliable. The driver was experienced and cooperative. Excellent service throughout!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Kavita Bhosale',
    role: 'Group Tour Organizer',
    text: 'Amruta Travels helped us organize a family pilgrimage from Pune to Tirupati and back. The bus was clean, air-conditioned, and perfectly suited for the long journey. Highly recommended for pan-India travel!',
    rating: 5,
  },
];
















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];



const allIndiaBusHireSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "All India Bus Hire Services From Pune",
  "image": "https://bushireinpune.com/assets/images/all-india-bus-hire.jpg", // Update with actual image URL
  "description": "Book buses from Pune for all India trips. Services include bus hire for Somnath, Badrinath, Kedarnath, Mysore Ooty, Goa, Rajasthan, and more. Available in various sizes like 14-seater, 17-seater, 20-seater, and 50-seater buses.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/all-india-bus-hire-services-from-pune"
  }
};








    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Explore All India Bus Hire Services From Pune | Somnath, Badrinath, Goa & More</title>
  <meta 
    name="description" 
    content="Book All India bus hire services from Pune for destinations like Somnath, Badrinath, Goa, Rajasthan, Mysore, and more. Available in 14-seater, 17-seater, 20-seater, and 50-seater buses." 
  />
  <script type="application/ld+json">
    {JSON.stringify(allIndiaBusHireSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/82.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Exploreallindiabushire;